import React, { useEffect, useState } from "react";
import { api, dateTimeFormat } from "../../lib/api";

const TYP_LABELS = {
  empfehlung_basis: "Empfehlung",
  empfehlung_quartals_bonus: "Quartals-Bonus",
  quartals_spezialbonus: "Spezial-Bonus",
  geschenk_einlosung: "Einlösung",
  manuelle_korrektur: "Korrektur (Admin)",
  verfall: "Verfall",
};

export default function CoinVerlauf() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/me/coin-verlauf").then((r) => setItems(r.data)); }, []);
  return (
    <div className="space-y-5" data-testid="coin-verlauf-page">
      <div>
        <h1 className="text-3xl font-heading font-bold text-falke-blue">Mein Coin-Verlauf</h1>
        <p className="text-falke-anthracite/70 mt-1">Alle Buchungen rund um deinen FalkeCoin-Saldo.</p>
      </div>
      {items.length === 0 && <div className="falke-card p-8 text-center text-falke-anthracite/60">Noch keine Buchungen.</div>}
      <div className="falke-card divide-y divide-falke-blue/10">
        {items.map((b) => (
          <div key={b.id} className="flex items-center justify-between px-5 py-4" data-testid={`buchung-${b.id}`}>
            <div>
              <div className="font-medium text-falke-anthracite">{b.beschreibung}</div>
              <div className="text-xs text-falke-anthracite/60">{TYP_LABELS[b.typ] || b.typ} · {dateTimeFormat(b.erstellt_am)}</div>
            </div>
            <div className={`font-heading text-xl tabular font-bold ${b.coins >= 0 ? "text-falke-success" : "text-rose-600"}`}>
              {b.coins >= 0 ? "+" : ""}{b.coins} FC
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
